import { exists } from './object.helpers.js';
export function isEmptyString(str) {
    return typeof str === 'string' && str.length === 0;
}
export function isNonEmptyString(str) {
    return typeof str === 'string' && str.length > 0;
}
/**
 * Returns `true` if the provided value is a string containing
 * only an integer number (e.g., `'10203'`).
 */
export function isIntegerString(str) {
    if (!exists(str)) {
        return false;
    }
    if (str.length < 1) {
        return false;
    }
    // do not consider decimal numbers
    if (str.includes('.')) {
        return false;
    }
    // avoiding parseInt() here, as it parses strings with postfix measurement units
    return !Number.isNaN(+str);
}
/**
 * Removes all non-alphanumeric characters in a string.
 */
export function removeSpecialChars(str) {
    // https://regex101.com/r/DJTaqH/1
    return (str || '').replace(/[^a-zA-Z0-9]/g, '');
}
